import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=8c31d5ac&scoped=true&"
import script from "./Countdown.vue?vue&type=script&lang=ts&"
export * from "./Countdown.vue?vue&type=script&lang=ts&"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=8c31d5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c31d5ac",
  null
  
)

export default component.exports